import { create } from 'zustand';

interface UIState {
  bottomBarOpen: boolean;
  sidebarMinimized: boolean;
  sidebarOpen: boolean;
  youtubeOn: boolean;
  aiImageEditorOpen: boolean;
  aiEditorOpen: boolean;
  showcase: any;
}

interface UIActions {
  setBottomBarOpen: (open: boolean) => void;
  setSidebarMinimized: (minimized: boolean) => void;
  setSidebarOpen: (open: boolean) => void;
  setYoutubeOn: (on: boolean) => void;
  setAIImageEditorOpen: (open: boolean) => void;
  setAIEditorOpen: (open: boolean) => void;
  setShowcase: (showcase: any) => void;
}

export const useUIStore = create<UIState & UIActions>((set) => ({
  // State
  bottomBarOpen: false,
  sidebarMinimized: true,
  sidebarOpen: false,
  youtubeOn: false,
  aiImageEditorOpen: false,
  aiEditorOpen: false,
  showcase: null,

  // Actions
  setBottomBarOpen: (open) => set({ bottomBarOpen: open }),
  setSidebarMinimized: (minimized) => set({ sidebarMinimized: minimized }),
  setSidebarOpen: (open) => set({ sidebarOpen: open }),
  setYoutubeOn: (on) => set({ youtubeOn: on }),
  setAIImageEditorOpen: (open) => set({ aiImageEditorOpen: open }),
  setAIEditorOpen: (open) => set({ aiEditorOpen: open }),
  setShowcase: (showcase) => set({ showcase }),
}));
